<template>
<div>
  <el-form ref="queryForm" :model="queryForm" label-width="260px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="是否开启" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="短信通道类型" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">阿里大鱼</el-radio>
            <el-radio :label="0">创蓝253</el-radio>
            <el-radio :label="2">亿美软通</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="AccessKeyId" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入AccessKeyId"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="AccessKeySecret" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入AccessKeySecret"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="签名" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入签名"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="验证码模版编号" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入验证码模版编号"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="审核账号通知" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="审核通知模版" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入审核通知模版"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="是否商家自主打款通知模版" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="商家自主打款通知模版" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入通知模版"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="是否开启登录手机验证码" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="登录验证码模版" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入通知模版"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="再次验证码间隔秒数" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入秒数"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>

  <div slot="header" class="clearfix">
    <span style="color: #409EFF">商家基本信息</span>
    <hr color="#aaa" size="0.2"/>
  </div>
  <el-form ref="queryForm" :model="queryForm1" label-width="260px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="充值审核通知" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="充值审核通知模版" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入通知模版"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="充值审核通知手机号" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
export default {
  name: "SmsSameComponent",
  mixins:[MixinCUD],
  data(){
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      tableData:[],
      queryForm:{
        isneedReview:0,
      },
      checkList: [],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      checkList1: []
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.demo-input-suffix {
  margin-bottom: 15px;
}
</style>
